import styled from "styled-components";

export const DashboardSection = styled.section`
  padding: 24px 0;
  border-bottom: 1px solid #15151b;
  color: #fff;
  min-width: 0;

  h2 {
    margin: 0;
    font-size: 22px;
    font-weight: 300;
  }

  p {
    color: #a5a5a8;
  }

  @media (max-width: 760px) {
    padding: 20px 0;
    h2 {
      font-size: 20px;
    }
  }
`;

export const TradersSearch = styled.label`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: min(100%, 380px);
  margin-bottom: 16px;
  color: #a5a5a8;
  font-size: 12px;

  input {
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #262630;
    border-radius: 8px;
    background: #101016;
    padding: 10px 12px;
    color: #fff;
    font: inherit;
  }
  input:focus-visible {
    outline: 2px solid #4cd7f4;
    outline-offset: 2px;
  }
`;

export const SectionHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 16px;

  > div {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }
`;

export const CountTag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 24px;
  color: #4cd7f4;
  background: rgba(76, 215, 244, 0.08);
  border-radius: 6px;
  padding: 0 10px;
  font-size: 12px;
  line-height: 16px;

  &::before {
    content: "";
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #4cd7f4;
  }
`;

export const SmallStat = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 72px;
  align-items: flex-end;

  small {
    color: #6a6a6d;
    font-size: 11px;
  }

  strong {
    color: #fff;
    font-size: 16px;
    font-weight: 400;
    font-variant-numeric: tabular-nums;
  }
`;

export const Stats = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 24px;
  flex-wrap: wrap;
`;

export const DataTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  font-variant-numeric: tabular-nums;

  th,
  td {
    height: 40px;
    padding: 0 8px;
    text-align: left;
    border-bottom: 1px solid #15151b;
    vertical-align: middle;
  }

  th {
    height: 32px;
    color: #6a6a6d;
    font-weight: 400;
    white-space: nowrap;
    text-transform: capitalize;
  }

  td {
    color: #a5a5a8;
  }

  tbody tr:hover {
    background: #18181e;
  }

  tbody tr.expandable {
    cursor: pointer;
  }

  td.primary {
    color: #fff;
  }

  td.address {
    overflow-wrap: anywhere;
    min-width: 130px;
  }

  .wallet-address {
    display: block;
    color: #6a6a6d;
    font-size: 11px;
    margin-top: 4px;
  }

  @media (max-width: 760px) {
    display: none;
  }
`;

export const IconButton = styled.button<{ $highlight?: boolean }>`
  height: 32px;
  min-width: 32px;
  border: 0;
  border-radius: 8px;
  padding: 0 10px;
  background: ${({ $highlight }) => ($highlight ? "#4cd7f4" : "#24242a")};
  color: ${({ $highlight }) => ($highlight ? "#000" : "#fff")};
  font: inherit;
  font-size: 12px;
  cursor: pointer;

  &:hover:not(:disabled) {
    box-shadow: inset 0 0 0 1px #fff;
  }

  &:focus-visible {
    outline: 2px solid #4cd7f4;
    outline-offset: 2px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  @media (max-width: 760px) {
    min-height: 44px;
    min-width: 44px;
  }
`;

export const ExpandedCell = styled.td`
  && {
    padding: 16px;
    background: #0e0e14;
  }
`;

export const FeePanels = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`;

export const FeePanel = styled.div`
  background: #12121a;
  border-radius: 8px;
  padding: 12px 16px;
  min-width: 0;

  h3 {
    margin: 0 0 8px;
    color: #6a6a6d;
    font-size: 11px;
    font-weight: 400;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
  }

  th,
  td {
    padding: 8px 4px;
    text-align: right;
    vertical-align: top;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  th:first-child,
  td:first-child {
    text-align: left;
  }

  th {
    color: #6a6a6d;
    font-weight: 400;
  }

  td {
    color: #a5a5a8;
  }

  td.current {
    color: #fff;
  }

  td.scheduled {
    color: #4cd7f4;
  }
`;

export const MobileCards = styled.div`
  display: none;

  @media (max-width: 760px) {
    display: grid;
    gap: 12px;
  }
`;

export const MobileCard = styled.article`
  padding: 16px;
  border: 1px solid #1a1a1f;
  border-radius: 8px;
  background: #12121a;
  min-width: 0;

  header {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: flex-start;
  }

  strong {
    color: #fff;
    font-weight: 500;
    overflow-wrap: anywhere;
  }

  small {
    color: #6a6a6d;
    display: block;
    margin-top: 4px;
  }

  .actions {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    margin-top: 16px;
    margin-bottom: 12px;
    button {
      flex: 1;
    }
  }
`;

export const MobileStats = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-top: 16px;

  > div {
    min-width: 0;
  }

  span {
    display: block;
    color: #6a6a6d;
    font-size: 11px;
  }

  strong {
    display: block;
    margin-top: 4px;
    font-size: 13px;
    font-weight: 400;
    font-variant-numeric: tabular-nums;
  }
`;

export const ExplanationGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin: 16px 0 24px;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const Explanation = styled.article`
  background: #12121a;
  border: 1px solid #1a1a1f;
  border-radius: 8px;
  padding: 16px;

  > span {
    color: #6a6a6d;
    font-size: 11px;
    letter-spacing: 1px;
  }

  h3 {
    margin: 12px 0 8px;
    font-size: 14px;
    font-weight: 400;
  }

  p {
    margin: 0;
    font-size: 12px;
    line-height: 1.5;
  }
`;

export const HistoryBox = styled.div`
  max-height: 232px;
  overflow-y: auto;

  th {
    position: sticky;
    top: 0;
    z-index: 1;
    background: #06060c;
  }

  @media (max-width: 760px) {
    max-height: 300px;
  }
`;

export const SubsectionHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin: 24px 0 8px;

  h3 {
    margin: 0;
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    color: #fff;
  }
  small {
    color: #6a6a6d;
    font-size: 11px;
  }
`;

export const WelcomeStrip = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  flex-wrap: wrap;
  padding: 12px 16px;
  border-radius: 8px;
  background: #12121a;
  border: 1px solid #1a1a1f;

  > div:first-child {
    flex: 1;
    min-width: 140px;
  }
  small {
    display: block;
    color: #6a6a6d;
    font-size: 11px;
    margin-bottom: 4px;
  }
  strong {
    color: #fff;
    font-size: 16px;
    font-weight: 400;
    font-variant-numeric: tabular-nums;
  }
  > div span {
    color: #a5a5a8;
    font-size: 12px;
  }
`;

const POINT_STATUS_COLORS: Record<
  string,
  { color: string; background: string }
> = {
  Available: { color: "#00e100", background: "rgba(0,225,0,.1)" },
  Pending: { color: "#4cd7f4", background: "rgba(76,215,244,.1)" },
  Expired: { color: "#fc0a54", background: "rgba(252,10,84,.1)" },
};
const DEFAULT_POINT_STATUS_COLORS = { color: "#a5a5a8", background: "#18181e" };

export const PointStatus = styled.span<{ $status: string }>`
  display: inline-flex;
  align-items: center;
  width: fit-content;
  min-height: 24px;
  padding: 0 9px;
  border-radius: 4px;
  color: ${({ $status }) =>
    (POINT_STATUS_COLORS[$status] || DEFAULT_POINT_STATUS_COLORS).color};
  background: ${({ $status }) =>
    (POINT_STATUS_COLORS[$status] || DEFAULT_POINT_STATUS_COLORS).background};
  font-size: 11px;
`;

export const BudgetActions = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;

  @media (max-width: 760px) {
    flex-direction: column;
    width: 100%;

    button {
      width: 100%;
    }
  }
`;

export const Warning = styled.p`
  color: #ff7a00 !important;
  font-size: 12px;
`;
